// AiChatModal.js
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AiChat from "./AiChat";
import "./styles.scss";

const AiChatModal = ({ active, setActive }) => {
  const modalParams = useSelector((state) => state.dashboard.modalParams);
  const history = useHistory();

  const closeModalHandler = () => {
    const isListPopupOpened =
      history.location.search.includes("&table") || history.location.search.includes("?table");
    const isStatisticsPage = history.location.pathname.includes("/statistics");

    if (isListPopupOpened || isStatisticsPage) {
      history.replace(history.location.pathname);
    }
    setActive(false);
  };

  return ReactDOM.createPortal(
    <div
      className={active ? "aichat-backdrop modal_active" : "backdrop"}
      onClick={closeModalHandler}>
      <div className={active ? "modal_active" : ""} onClick={(e) => e.stopPropagation()}>
        <AiChat
          onClose={closeModalHandler}
          promptSuggestions={modalParams.promptSuggestions}
          opensession={modalParams.opensession}
        />
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default AiChatModal;
